import React, { useState } from "react";
import Body from "./Body";
const Dashboard = () => {
  const [classesFilter, setClassesFilter] = useState("");
  const [genderWaysFilter, setGenderWaysFilter] = useState("");
  const [lineChartFilter, setLineChartFilter] = useState("");

  const [overViewCardData, setOverViewCardData] = useState([
    {
      title: "Students",
      presentCount: "1200",
      cardType: "regular",
      bgColor: "#E8F0FF", // Light blue
      icon: "user", // Optional: add icon name if you use one
    },
    {
      title: "Teachers",
      presentCount: "105",
      cardType: "regular",
      bgColor: "#FFE6E6", // Light red/pink
      icon: "users",
    },
    {
      title: "Today's Events",
      presentCount: "105",
      cardType: "regular",
      bgColor: "#E3FFE9", // Light green
      icon: "calendar-check",
    },
    {
      title: "Rest of the books",
      presentCount: "105",
      cardType: "regular",
      bgColor: "#EFE7E5", // Light brown/grey
      icon: "book",
    },
  ]);

  const [lineChartData, setLineChartData] = useState([
    { date: "Aug 1", blueLine: 400, redLine: 240, purpleLine: 200 },
    { date: "Aug 2", blueLine: 500, redLine: 220, purpleLine: 120 },
    { date: "Aug 3", blueLine: 830, redLine: 600, purpleLine: 300 },
    { date: "Aug 4", blueLine: 870, redLine: 550, purpleLine: 650 },
    { date: "Aug 5", blueLine: 600, redLine: 340, purpleLine: 520 },
    { date: "Aug 6", blueLine: 480, redLine: 720, purpleLine: 600 },
    { date: "Aug 7", blueLine: 350, redLine: 260, purpleLine: 670 },
  ]);
  const [absenteesData, setAbsenteesData] = useState([
    {
      id: "1",
      image: "https://randomuser.me/api/portraits/men/11.jpg",
      name: "Aarav Sharma",
      date: "2025-06-21",
      class: "Class 4",
    },
    {
      id: "2",
      image: "https://randomuser.me/api/portraits/women/21.jpg",
      name: "Diya Patel",
      date: "2025-06-20",
      class: "Class 9",
    },
    {
      id: "3",
      image: "https://randomuser.me/api/portraits/men/31.jpg",
      name: "Rohan Verma",
      date: "2025-06-19",
      class: "Class 6",
    },
    {
      id: "4",
      image: "https://randomuser.me/api/portraits/women/41.jpg",
      name: "Ananya Reddy",
      date: "2025-06-20",
      class: "Class 8",
    },
    {
      id: "5",
      image: "https://randomuser.me/api/portraits/men/51.jpg",
      name: "Ishaan Deshmukh",
      date: "2025-06-18",
      class: "Class 5",
    },
    {
      id: "6",
      image: "https://randomuser.me/api/portraits/women/61.jpg",
      name: "Sneha Nair",
      date: "2025-06-20",
      class: "Class 7",
    },
    {
      id: "7",
      image: "https://randomuser.me/api/portraits/men/71.jpg",
      name: "Karthik Rao",
      date: "2025-06-17",
      class: "Class 6",
    },
    {
      id: "8",
      image: "https://randomuser.me/api/portraits/women/81.jpg",
      name: "Meera Joshi",
      date: "2025-06-19",
      class: "Class 5",
    },
    {
      id: "9",
      image: "https://randomuser.me/api/portraits/men/91.jpg",
      name: "Yash Mehta",
      date: "2025-06-20",
      class: "Class 4",
    },
    {
      id: "10",
      image: "https://randomuser.me/api/portraits/women/15.jpg",
      name: "Ritika Singh",
      date: "2025-06-18",
      class: "Class 9",
    },
    {
      id: "11",
      image: "https://randomuser.me/api/portraits/men/25.jpg",
      name: "Arjun Kapoor",
      date: "2025-06-19",
      class: "Class 10",
    },
    {
      id: "12",
      image: "https://randomuser.me/api/portraits/women/35.jpg",
      name: "Priya Malhotra",
      date: "2025-06-20",
      class: "Class 6",
    },
    {
      id: "13",
      image: "https://randomuser.me/api/portraits/men/45.jpg",
      name: "Vivaan Bansal",
      date: "2025-06-20",
      class: "Class 5",
    },
    {
      id: "14",
      image: "https://randomuser.me/api/portraits/women/55.jpg",
      name: "Sanya Iyer",
      date: "2025-06-18",
      class: "Class 7",
    },
    {
      id: "15",
      image: "https://randomuser.me/api/portraits/men/65.jpg",
      name: "Devansh Choudhary",
      date: "2025-06-17",
      class: "Class 8",
    },
  ]);

  const [onleaveData, setOnleaveData] = useState([
    {
      id: "1",
      image: "https://randomuser.me/api/portraits/men/12.jpg",
      name: "Rajesh Kumar",
      date: "2025-06-20",
      designation: "Teacher",
    },
    {
      id: "2",
      image: "https://randomuser.me/api/portraits/women/22.jpg",
      name: "Pooja Sharma",
      date: "2025-06-21",
      designation: "Class teacher",
    },
    {
      id: "3",
      image: "https://randomuser.me/api/portraits/men/32.jpg",
      name: "Amitabh Sinha",
      date: "2025-06-18",
      designation: "Staff",
    },
    {
      id: "4",
      image: "https://randomuser.me/api/portraits/women/42.jpg",
      name: "Neha Joshi",
      date: "2025-06-19",
      designation: "Non-teaching staff",
    },
    {
      id: "5",
      image: "https://randomuser.me/api/portraits/men/52.jpg",
      name: "Ravi Verma",
      date: "2025-06-20",
      designation: "Teacher",
    },
    {
      id: "6",
      image: "https://randomuser.me/api/portraits/women/62.jpg",
      name: "Sneha Reddy",
      date: "2025-06-20",
      designation: "Class teacher",
    },
    {
      id: "7",
      image: "https://randomuser.me/api/portraits/men/72.jpg",
      name: "Karan Iyer",
      date: "2025-06-19",
      designation: "Staff",
    },
    {
      id: "8",
      image: "https://randomuser.me/api/portraits/women/82.jpg",
      name: "Simran Desai",
      date: "2025-06-18",
      designation: "Non-teaching staff",
    },
    {
      id: "9",
      image: "https://randomuser.me/api/portraits/men/92.jpg",
      name: "Dev Mishra",
      date: "2025-06-21",
      designation: "Teacher",
    },
    {
      id: "10",
      image: "https://randomuser.me/api/portraits/women/16.jpg",
      name: "Kritika Bansal",
      date: "2025-06-17",
      designation: "Class teacher",
    },
  ]);
  const [staffAppearanceData, setStaffAppearanceData] = useState([
    {
      id: "1",
      name: "Toufik Alam",
      staffId: "SM0523019",
      designation: "Warden - Hostel B",
      time: "9:30 AM",
      image: "https://randomuser.me/api/portraits/men/41.jpg",
    },
    {
      id: "2",
      name: "Mustak Ahamed",
      staffId: "SM0721011",
      designation: "Warden - Hostel A",
      time: "9:30 AM",
      image: "https://randomuser.me/api/portraits/men/42.jpg",
    },
    {
      id: "3",
      name: "Anisur Islam",
      staffId: "SM0824109",
      designation: "Food Manager",
      time: "9:30 AM",
      image: "https://randomuser.me/api/portraits/men/43.jpg",
    },
    {
      id: "4",
      name: "Rohit Khan",
      staffId: "SM1223099",
      designation: "Head Security",
      time: "9:30 AM",
      image: "https://randomuser.me/api/portraits/men/44.jpg",
    },
    {
      id: "5",
      name: "Priya Sharma",
      staffId: "SM0322108",
      designation: "Librarian",
      time: "9:30 AM",
      image: "https://randomuser.me/api/portraits/women/41.jpg",
    },
    {
      id: "6",
      name: "Ramesh Rao",
      staffId: "SM0923101",
      designation: "Admin Head",
      time: "9:30 AM",
      image: "https://randomuser.me/api/portraits/men/45.jpg",
    },
    {
      id: "7",
      name: "Sana Fatima",
      staffId: "SM0523105",
      designation: "Matron - Hostel C",
      time: "9:30 AM",
      image: "https://randomuser.me/api/portraits/women/42.jpg",
    },
    {
      id: "8",
      name: "Amit Roy",
      staffId: "SM0712987",
      designation: "Transport Incharge",
      time: "9:30 AM",
      image: "https://randomuser.me/api/portraits/men/46.jpg",
    },
    {
      id: "9",
      name: "Fatima Zafar",
      staffId: "SM0823123",
      designation: "Receptionist",
      time: "9:30 AM",
      image: "https://randomuser.me/api/portraits/women/43.jpg",
    },
    {
      id: "10",
      name: "Harshit Tiwari",
      staffId: "SM0932104",
      designation: "Sports Coordinator",
      time: "9:30 AM",
      image: "https://randomuser.me/api/portraits/men/47.jpg",
    },
    {
      id: "11",
      name: "Kiran Joshi",
      staffId: "SM0132112",
      designation: "Counselor",
      time: "9:30 AM",
      image: "https://randomuser.me/api/portraits/women/44.jpg",
    },
    {
      id: "12",
      name: "Dev Mehta",
      staffId: "SM0422133",
      designation: "Network Admin",
      time: "9:30 AM",
      image: "https://randomuser.me/api/portraits/men/48.jpg",
    },
    {
      id: "13",
      name: "Zoya Ahmed",
      staffId: "SM1122033",
      designation: "Assistant Warden",
      time: "9:30 AM",
      image: "https://randomuser.me/api/portraits/women/45.jpg",
    },
    {
      id: "14",
      name: "Nikhil Bansal",
      staffId: "SM0622098",
      designation: "Security Supervisor",
      time: "9:30 AM",
      image: "https://randomuser.me/api/portraits/men/49.jpg",
    },
    {
      id: "15",
      name: "Shreya Kapoor",
      staffId: "SM0732011",
      designation: "Cleaning Head",
      time: "9:30 AM",
      image: "https://randomuser.me/api/portraits/women/46.jpg",
    },
    {
      id: "16",
      name: "Tushar Sinha",
      staffId: "SM0532097",
      designation: "Maintenance Officer",
      time: "9:30 AM",
      image: "https://randomuser.me/api/portraits/men/50.jpg",
    },
    {
      id: "17",
      name: "Lavanya Reddy",
      staffId: "SM0221103",
      designation: "Accountant",
      time: "9:30 AM",
      image: "https://randomuser.me/api/portraits/women/47.jpg",
    },
    {
      id: "18",
      name: "Aarav Verma",
      staffId: "SM0911120",
      designation: "Office Clerk",
      time: "9:30 AM",
      image: "https://randomuser.me/api/portraits/men/51.jpg",
    },
    {
      id: "19",
      name: "Neha Kumari",
      staffId: "SM0732140",
      designation: "Inventory Manager",
      time: "9:30 AM",
      image: "https://randomuser.me/api/portraits/women/48.jpg",
    },
    {
      id: "20",
      name: "Rajiv Das",
      staffId: "SM0632119",
      designation: "Transport Staff",
      time: "9:30 AM",
      image: "https://randomuser.me/api/portraits/men/52.jpg",
    },
  ]);
  const [tuitionScheduleData, setTuitionScheduleData] = useState([
    { id: "1", shift: "Morning", batches: 5, totalStudents: 350 },
    { id: "2", shift: "Evening", batches: 8, totalStudents: 552 },
    { id: "3", shift: "Morning", batches: 4, totalStudents: 310 },
    { id: "4", shift: "Evening", batches: 7, totalStudents: 470 },
    { id: "5", shift: "Morning", batches: 6, totalStudents: 390 },
    { id: "6", shift: "Evening", batches: 5, totalStudents: 420 },
    { id: "7", shift: "Morning", batches: 3, totalStudents: 280 },
    { id: "8", shift: "Evening", batches: 6, totalStudents: 498 },
    { id: "9", shift: "Morning", batches: 4, totalStudents: 340 },
    { id: "10", shift: "Evening", batches: 8, totalStudents: 525 },
    { id: "11", shift: "Morning", batches: 5, totalStudents: 365 },
    { id: "12", shift: "Evening", batches: 7, totalStudents: 490 },
    { id: "13", shift: "Morning", batches: 6, totalStudents: 410 },
    { id: "14", shift: "Evening", batches: 5, totalStudents: 455 },
    { id: "15", shift: "Morning", batches: 4, totalStudents: 300 },
  ]);

  const _this = {
    classesFilter,
    setClassesFilter,
    genderWaysFilter,
    setGenderWaysFilter,
    overViewCardData,
    setOverViewCardData,

    lineChartFilter,
    setLineChartFilter,

    lineChartData,
    setLineChartData,

    absenteesData,
    setAbsenteesData,
    onleaveData,
    setOnleaveData,
    staffAppearanceData,
    setStaffAppearanceData,
    tuitionScheduleData,
    setTuitionScheduleData,
  };
  return <Body {..._this} />;
};

export default Dashboard;
